import { doGetPromotic } from './Api';

export default class GetBenefits {
    static async responseGetBenefits() {  
        const response = await doGetPromotic(process.env.REACT_APP_GET_PROTECCION_QUE_PREMIA );
    return response.data.data;
  }
}
